import { useEffect, useState } from "react"
import { useLocation } from "react-router-dom"
import { useGetLandingTracking } from "../hooks/Landing/useGetLandingTracking"
import { initializeTracking, trackPageView } from "./tracking"
import { isStorePublicTrackingPath } from "./trackingRoutes"

const TrackingInitializer = () => {
  const { pathname, search } = useLocation()

  const { handleGetLandingTracking } = useGetLandingTracking()

  const [isInitialized, setIsInitialized] = useState(false)

  const isStorePublicPath = isStorePublicTrackingPath(pathname)

  useEffect(() => {
    if (isStorePublicPath || isInitialized) {
      return
    }

    let active = true

    handleGetLandingTracking()
      .then((config) => {
        if (!active) {
          return
        }

        initializeTracking(config)
        setIsInitialized(true)
      })
      .catch(() => {})

    return () => {
      active = false
    }
  }, [handleGetLandingTracking, isInitialized, isStorePublicPath])

  useEffect(() => {
    if (isStorePublicPath || !isInitialized) {
      return
    }

    trackPageView(`${pathname}${search}`, document.title)
  }, [isInitialized, isStorePublicPath, pathname, search])

  return null
}

export default TrackingInitializer
